export var COUNT_TEXT_IOS = 'более 134 тыс.';
export var COUNT_TEXT_ANDROID = 'более 107 тыс.';
export var BUTTON_TEXT_IOS = 'Скачать в App Store';
export var BUTTON_TEXT_ANDROID = 'Скачать в Google Play';